import PreClassPreparationStage from "@/components/course-progress/stages/PreClassPreparationStage";

export default function PreClassPreparation() {
  return <PreClassPreparationStage mode="student" />;
}
